import React from 'react';

type Status =
  | 'Allowed'
  | 'Prohibited'
  | 'Unverified'
  | 'Unverified User'
  | 'Allowed Publisher'
  | 'Allowed Developer'
  | 'Prohibited Publisher'
  | 'Prohibited Developer'
  | 'Allowed Admin'
  | 'Prohibited Admin'
  | 'PENDING'
  | 'APPROVED'
  | 'REJECTED';

const statusStyles: Record<Status, { bg: string; text: string; dot: string }> =
  {
    Allowed: {
      bg: 'bg-blue-100',
      text: 'text-blue-600',
      dot: 'bg-blue-600',
    },
    Prohibited: {
      bg: 'bg-slate-200',
      text: 'text-slate-400',
      dot: 'bg-slate-400',
    },
    Unverified: {
      bg: 'bg-yellow-100',
      text: 'text-yellow-500',
      dot: 'bg-yellow-500',
    },
    'Unverified User': {
      bg: 'bg-yellow-100',
      text: 'text-yellow-500',
      dot: 'bg-yellow-500',
    },
    'Allowed Developer': {
      bg: 'bg-blue-100',
      text: 'text-blue-600',
      dot: 'bg-blue-600',
    },
    'Allowed Publisher': {
      bg: 'bg-blue-100',
      text: 'text-blue-600',
      dot: 'bg-blue-600',
    },
    'Prohibited Publisher': {
      bg: 'bg-slate-200',
      text: 'text-slate-400',
      dot: 'bg-slate-400',
    },
    'Prohibited Developer': {
      bg: 'bg-slate-200',
      text: 'text-slate-400',
      dot: 'bg-slate-400',
    },
    'Allowed Admin': {
      bg: 'bg-blue-100',
      text: 'text-blue-600',
      dot: 'bg-blue-600',
    },
    'Prohibited Admin': {
      bg: 'bg-slate-200',
      text: 'text-slate-400',
      dot: 'bg-slate-400',
    },
    'PENDING': {
      bg: 'bg-yellow-100',
      text: 'text-yellow-600',
      dot: 'bg-yellow-600',
    },
    'APPROVED': {
      bg: 'bg-green-100',
      text: 'text-green-600',
      dot: 'bg-green-600',
    },
    'REJECTED': {
      bg: 'bg-red-100',
      text: 'text-red-600',
      dot: 'bg-red-600',
    },
  };

interface IndicatorProps {
  status: Status;
}

const Indicator: React.FC<IndicatorProps> = ({ status }) => {
  const { bg, text, dot } = statusStyles[status];

  return (
    
    <span
      className={`inline-flex items-center px-2 py-0.5 text-xs font-normal ${text} ${bg} rounded-full sm:px-2.5 sm:py-0.5 sm:text-sm md:px-3 md:py-0.5 md:text-sm whitespace-nowrap`}
    >
      <span data-testid="status-dot" className={`w-2 h-2 ${dot} rounded-full mr-1`}></span>
      {status}
    </span>
  );
};

export default Indicator;
